module.exports = __webpack_public_path__ + "static/media/fun2.9a80dbb6.png";